import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {shallowEqual, useSelector} from 'react-redux'
import {UserModel} from '../../../../app/modules/auth/models/UserModel'
import {RootState} from '../../../../setup'

export function AsideMenuMain() {
  const intl = useIntl()
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      {/* //==================== Location ===================== */}
      <AsideMenuItemWithSub
        to='/locations'
        title='Locations'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen025.svg'
      >
        <AsideMenuItem to='/locations/country' title='Country' hasBullet={true} />
        <AsideMenuItem to='/locations/state' title='State' hasBullet={true} />
        <AsideMenuItem to='/locations/city' title='City' hasBullet={true} />
        <AsideMenuItem to='/locations/areapincode' title='Area Pincode' hasBullet={true} />
        {/* <AsideMenuItem to='/locations/taluka' title='Taluka' hasBullet={true} /> */}
        {/* <AsideMenuItem to='/locations/society' title='Society' hasBullet={true} /> */}
        {/* <AsideMenuItem to='/locations/pickup-drop-point' title='Kiosk Point' hasBullet={true} /> */}
        {/* <AsideMenuItem to='/locations/service-center' title='Service Center' hasBullet={true} /> */}
      </AsideMenuItemWithSub>

      {/* <AsideMenuItem
        to='/builder'
        icon='/media/icons/duotune/general/gen019.svg'
        title='Builder Layout'
        fontIcon='bi-layers'
      /> */}

      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Menu</span>
        </div>
      </div> */}

      {/* ======================================Lab test mng========================================= */}
      <AsideMenuItemWithSub
        to='/labtestmng'
        title='Lab Test Manage'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
        // dislpay={user.roleID === 4 ? 'd-none' : ''}
      >
        {/* <AsideMenuItem
          to='/master/service-subcategory'
          title='Service Sub Category'
          hasBullet={true}
        /> */}
        <AsideMenuItem to='/labtestmng/colllection' title='Collection ' hasBullet={true} />
        <AsideMenuItem to='/labtestmng/parameter-unit' title='Parameter Unit' hasBullet={true} />
        <AsideMenuItem to='/labtestmng/test-parameter' title=' Test Parameter' hasBullet={true} />
        <AsideMenuItem
          to='/labtestmng/test-instruction'
          title='Test Instruction'
          hasBullet={true}
        />
        <AsideMenuItem to='/labtestmng/prerequired' title='Pre Required' hasBullet={true} />
        <AsideMenuItem to='/labtestmng/pickup-schedule' title='Pickup Schedule' hasBullet={true} />
        <AsideMenuItem to='/labtestmng/tests' title='Test' hasBullet={true} />
        <AsideMenuItem to='/labtestmng/test-category' title='Test Category' hasBullet={true} />
        <AsideMenuItem to='/labtestmng/speciality' title='Specialist' hasBullet={true} />
        {/* <AsideMenuItem to='/labtestmng/test-type' title='Test Type' hasBullet={true} /> */}
        {/* <AsideMenuItem to='/master/kycdocument' title='Kyc Document' hasBullet={true} /> */}
      </AsideMenuItemWithSub>

      {/* ********************************************************************************************************** */}

      <AsideMenuItemWithSub
        to='/master'
        title='Master'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
        // dislpay={user.roleID === 4 ? 'd-none' : ''}
      >
        {/* <AsideMenuItem
          to='/master/service-subcategory'
          title='Service Sub Category'
          hasBullet={true}
        /> */}
        <AsideMenuItem to='/master/bannerimage' title='Bannner Image' hasBullet={true} />
        {/* <AsideMenuItem to='/master/branch' title='Branch' hasBullet={true} /> */}
        <AsideMenuItem to='/master/department' title='Department' hasBullet={true} />
        <AsideMenuItem to='/master/designation' title='Designation' hasBullet={true} />
        <AsideMenuItem to='/master/doctor-degree' title='Doctor Degree' hasBullet={true} />
        <AsideMenuItem to='/master/documenttype' title='Document Type' hasBullet={true} />
        <AsideMenuItem to='/master/eduCategory' title='Education Category' hasBullet={true} />
        <AsideMenuItem to='/master/eduDepartment' title='Education Department' hasBullet={true} />
        <AsideMenuItem to='/master/homevideo' title='Home Video' hasBullet={true} />
        <AsideMenuItem to='/master/nationality' title='Nationality' hasBullet={true} />
        <AsideMenuItem to='/master/offer' title='Offer' hasBullet={true} />
        <AsideMenuItem to='/master/coupon' title='Coupon' hasBullet={true} />
        {/* <AsideMenuItem to='/master/kycdocument' title='Kyc Document' hasBullet={true} /> */}
      </AsideMenuItemWithSub>
      {/* ========================================================================== */}
      {/* <AsideMenuItemWithSub
        to='/order'
        title='Order'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
        // dislpay={user.roleID === 4 ? 'd-none' : ''}
      >
        <AsideMenuItem to='/order/test-lab' title='Test Lab' hasBullet={true} />
        <AsideMenuItem to='/order/redilogys' title='Rediology Home' hasBullet={true} />
        <AsideMenuItem to='/order/redilogy-lab' title='Rediology Lab' hasBullet={true} />
        <AsideMenuItem to='/order/healthcare' title='Health Care' hasBullet={true} />
      </AsideMenuItemWithSub> */}

      <AsideMenuItemWithSub
        to='/order-management'
        title='Order Management'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      >
        <AsideMenuItemWithSub
          to='/order-management/by-customer'
          title='By Customer'
          hasBullet={true}
        >
          <AsideMenuItem
            to='/order-management/by-customer/test-lab'
            title='Test Lab'
            hasBullet={true}
          />
          <AsideMenuItem
            to='/order-management/by-customer/redilogys-home'
            title='Rediology Home'
            hasBullet={true}
          />
          <AsideMenuItem
            to='/order-management/by-customer/redilogy-lab'
            title='Rediology Lab'
            hasBullet={true}
          />
          <AsideMenuItem
            to='/order-management/by-customer/health-care'
            title='Health Care'
            hasBullet={true}
          />
        </AsideMenuItemWithSub>
        <AsideMenuItemWithSub to='/order-management/by-doctor' title='By Doctor' hasBullet={true}>
          <AsideMenuItem
            to='/order-management/by-doctor/test-lab'
            title='Test Lab'
            hasBullet={true}
          />
          <AsideMenuItem
            to='/order-management/by-doctor/redilogys-home'
            title='Rediology Home'
            hasBullet={true}
          />
          <AsideMenuItem
            to='/order-management/by-doctor/redilogy-lab'
            title='Rediology Lab'
            hasBullet={true}
          />
        </AsideMenuItemWithSub>
      </AsideMenuItemWithSub>
      {/* //==================== Product Manage ===================== */}
      {/* <AsideMenuItemWithSub
        to='/product-manage'
        title='Product Manage'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen019.svg'
      >
        <AsideMenuItem to='/product-manage/service-category' title='Service' hasBullet={true} />
        <AsideMenuItem
          to='/product-manage/item-category'
          title='Product Category'
          hasBullet={true}
        />
        <AsideMenuItem to='/product-manage/items' title='Product' hasBullet={true} />
        <AsideMenuItem to='/master/laundry-type' title='Laundry Type' hasBullet={true} />
        <AsideMenuItem to='/product-manage/driver-tip' title='Driver Tip' hasBullet={true} />
      </AsideMenuItemWithSub> */}

      {/* //============== Organization ================================= */}
      <AsideMenuItemWithSub
        to='/organization'
        title='Organization'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen025.svg'
        // dislpay={user.roleID === 4 ? 'd-none' : ''}
      >
        <AsideMenuItem to='/organization/employee' title='Employee' hasBullet={true} />
        <AsideMenuItem to='/organization/user' title='User' hasBullet={true} />
        <AsideMenuItem to='/organization/customer' title='Customer' hasBullet={true} />
      </AsideMenuItemWithSub>

      {/* =======================Lab============== */}
      <AsideMenuItem
        to='/lab'
        title='Lab Master'
        icon='/media/icons/duotune/general/gen017.svg'
        fontIcon='bi-layers'
      />
      {/* =======================Doctor============== */}
      <AsideMenuItem
        to='/doctors'
        title='Doctor'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen025.svg'
      />
      {/* =======================Prescription============== */}
      <AsideMenuItem
        to='/prescription'
        title='Prescription'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      />

      <AsideMenuItemWithSub
        to='/payment'
        title='Payment'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/finance/fin008.svg'
        // dislpay={user.roleID === 4 ? 'd-none' : ''}
      >
        <AsideMenuItem to='/payment/lab-payment-report' title='Lab Payment' hasBullet={true} />
        <AsideMenuItem
          to='/payment/doctor-payment-report'
          title='Doctor Payment'
          hasBullet={true}
        />
      </AsideMenuItemWithSub>

      <AsideMenuItem
        to='/withdraw-request'
        title='Withdraw Request'
        icon='/media/icons/duotune/finance/fin007.svg'
        fontIcon='bi-layers'
      />
      {/* =======================Test Type============== */}

      {/* =======================Doctor============== */}
      {/* <AsideMenuItem
        to='/doctor-patient'
        title='Doctor Patient'
        icon='/media/icons/duotune/general/gen017.svg'
        fontIcon='bi-layers'
      /> */}
      {/* //============== Schedules ================================= */}
      {/* <AsideMenuItemWithSub
        to='/schedules'
        title='Schedules'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen012.svg'
        // dislpay={user.roleID === 4 ? 'd-none' : ''}
      >
        <AsideMenuItem to='/schedules/pickup-schedule' title='Pickup Schedule' hasBullet={true} />
        <AsideMenuItem
          to='/schedules/delivery-schedule'
          title='Delivery Schedule'
          hasBullet={true}
        />
      </AsideMenuItemWithSub> */}
      {/* =================================Configuration=========================== */}
      {/* <AsideMenuItem
        to='/configuration'
        title='Configuration'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen011.svg'
      /> */}
      {/* ===================================Offer Master================================ */}
      {/* <AsideMenuItem
        to='/offer'
        title='Offer'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      /> */}

      {/* //============== Orders ================================= */}
      {/* <AsideMenuItemWithSub
        to='/orders'
        title='Orders'
        fontIcon='bi-layers'
        icon='/media/icons/duotune/general/gen017.svg'
        // dislpay={user.roleID === 4 ? 'd-none' : ''}
      >
        <AsideMenuItem to='/orders/open-order' title='Open Order' hasBullet={true} />
        <AsideMenuItem to='/orders/offline-order' title='Offline Order' hasBullet={true} />
        <AsideMenuItem to='/orders/close-order' title='Close Order' hasBullet={true} />
        <AsideMenuItem to='/orders/mismatch-order' title='Mismatch Order' hasBullet={true} />
        <AsideMenuItem to='/orders/critical-order' title='Critical Order' hasBullet={true} /> */}
      {/* <AsideMenuItem to='/orders/tip-manage' title='Tip Manage' hasBullet={true} /> */}
      {/* <AsideMenuItem to='/orders/feedback' title='Feedback' hasBullet={true} /> */}
      {/* <AsideMenuItem to='/orders/reports' title='Reports' hasBullet={true} /> */}
      {/* </AsideMenuItemWithSub> */}

      {/* ==================================== GST Report ================================== */}
      {/* <AsideMenuItem
        to='/gst-report'
        title='GST Report'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      /> */}

      {/* ==================================== Payment Report ================================== */}
      {/* <AsideMenuItemWithSub
        title='Payment Reports'
        to='/payment-reports'
        icon='/media/icons/duotune/communication/com012.svg'
        fontIcon='bi-archive'
      >
        <AsideMenuItem
          to='/payment-reports/daywise-payment-report'
          title='Daily Payment Reports'
          hasBullet={true}
        />
        <AsideMenuItem
          to='/payment-reports/monthwise-payment-report'
          title='Monthly Payment Reports'
          hasBullet={true}
        />
      </AsideMenuItemWithSub> */}
      {/* ************************************************ fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'********************************************************** */}
      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div>

      <AsideMenuItemWithSub
        to='/crafted/pages'
        title='Pages'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen022.svg'
      >
        <AsideMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <AsideMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
          <AsideMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </AsideMenuItemWithSub>

        <AsideMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <AsideMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <AsideMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </AsideMenuItemWithSub>
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <AsideMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/error'
        title='Errors'
        fontIcon='bi-sticky'
        icon='/media/icons/duotune/general/gen040.svg'
      >
        <AsideMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <AsideMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='/media/icons/duotune/general/gen025.svg'
        fontIcon='bi-layers'
      >
        <AsideMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </AsideMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      <AsideMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/communication/com012.svg'
      >
        <AsideMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <AsideMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <AsideMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </AsideMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
      <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}
